/* eslint-disable */

var LocationService = require('../locationservice');
var UIAlert = require('./alert');

/** @description Please feel free to delete me when we stop supporting this rubbish
    @param {Element} elem
    @returns {void} */



/** @constructor
    @param {Element} node The component root host element
    @param {Boolean} TRUE = the component stays hidden after initialization
                     FALSE = the component will get visible after initialization
    @param {Array<string>} [restrictions] */
function UILocationSearch(node, hiddenAtStart, restrictions){

    if (!node) {
        return;
    }

    this.__hostElement = node;
    this.__searchRestrictions = restrictions || LocationService.defaultRestrictions;

    this.__hostElement.addEventListener("keydown", this.onkeydown.bind(this), false);

    this.__input = this.__hostElement.querySelector("input");
    this.__input.removeAttribute("required");
    this.__input.addEventListener("input", this.oninput.bind(this), false);
    this.__input.addEventListener("keyup", this.onkeychange.bind(this), false);
    this.__input.addEventListener("focus", this.onfocus.bind(this), false);
    this.__input.addEventListener("blur", this.onblur.bind(this), false);

    this.__suggestionlist = this.__hostElement.querySelector("[data-anonid='suggestionlist']");
    this.__suggestionlist.addEventListener("mousedown", this.onselect.bind(this), false);
    this.__suggestionlist.addEventListener("touchend", this.onselect.bind(this), false);
    this.__suggestionlist.addEventListener("mouseover", this.onselect.bind(this), false);

    this.__hostElement.querySelector("[data-anonid='search']").addEventListener("click", this.search.bind(this), false);
    this.__hostElement.querySelector("[data-anonid='clear']").addEventListener("click", this.clear.bind(this), false);
    this.__hostElement.querySelector("[data-anonid='change']").addEventListener("click", this.clear.bind(this), false);

    this.__geolocate = this.__hostElement.querySelector("[data-anonid='geolocate'] > button");
    this.__geolocation = this.__hostElement.getAttribute("data-geolocation") == 'true' ? true : false;

    this.__geolocate.addEventListener("click", this.geolocate.bind(this), false);

    if(this.__isGeolocationAvailable()){
        this.__setupGeolocation(true);
    }
    else {
        this.__setupGeolocation(false);
        this.__hostElement.setAttribute("data-geolocation", false);
        this.__geolocation = false;
    }

    if(!window.App.Platform.isMobile()) {
        this.__autofocus = this.__hostElement.getAttribute("data-autofocus") == 'true' ? true : false;
    }

    this.__currentLocation = this.__hostElement.querySelector("[data-anonid='current'] > H3");

    this.__showLabel = this.__hostElement.hasAttribute('data-show-label');

    LocationService.addEventListener("locationstatechange", this.onlocationstatechange.bind(this), false);
    LocationService.addEventListener("clearlocation", this.onclearlocation.bind(this), false);

    // Needs to be re-enabled with better Smarty localisation for Listing page
    this.setLabel(window.App.locale.getString("component.mcd.postcodechecker.label"));

    if (!hiddenAtStart) {
        this.__hostElement.removeAttribute("hidden");
    }
}
UILocationSearch.prototype = {
    /** @type {Element} */
    __hostElement : null,

    /** @type {Element} */
    __input : null,

    /** @type {Boolean} Auto-focus the input field */
    __autofocus : false,

    /** @type {Boolean} Component wants active focus */
    __activeElement : false,

    /** @type {Boolean} */
    __geolocation : false,

    /** @type {string} The actual text entered before autocomplete */
    __textInput : "",

    /** @type {Element} */
    __geolocate : null,

    /** @type {number} */
    /** @description Selected Suggestion is an index into the array of current LocationDescriptors suggestions and the DOM suggestion list */
    __selectedSuggestion : null,

    /** @type {Array<LocationDescriptor>} */
    __currentSuggestions : [],

    /** @type {Array<string>}
        @description Search restrictions to restrict results against */
    __searchRestrictions : [],

    /** @type {Boolean}
        @description Set true when a user initiated the location search, clear location
                     or geolocation using this instance of the component */
    __isInUserInteraction : false,

    /** @type {Object}
        @description Use case object.
                     Keeps page type + detailed description for analytics purposes.
                     Set by this.setUseCase(page, description) */
    __useCase : {},

    /** @type {UIAlert} Alert object for message boxes */
    __alert : null,

    /** @returns {HTMLElement} */
    getHostElement : function(){
        return this.__hostElement;
    },

    /** @returns {void} */
    clear : function(e){
        this.hideSuggestions();
        this.clearSuggestions();
        this.__activeElement = true;
        this.__isInUserInteraction = true;
        LocationService.clearLocation();
        this.__input.focus();
    },

    /** @returns {void} */
    search : function(isAutoComplete){
        if(this.__selectedSuggestion !== null){
            this.hideSuggestions();
            this.__input.blur();
            var location = this.__currentSuggestions[this.__selectedSuggestion];
            location.source = LocationService.LocationSource.INTERACTIVE;
            location.useCase = this.__useCase;

            if(isAutoComplete === true) {
                location.useCase.description = 'autocomplete';
            }

            this.__isInUserInteraction = true;
            LocationService.setLocation(location);
        }
    },

    searchCurrentLocationDescriptor: function() {
        // Close error message before sending new availability request
        this.__alert && this.__alert.close();

        LocationService.searchCurrentLocationDescriptor()
    },

    /** @returns {void} */
    autocomplete : function(searchFirstSuggested){
        var self = this;
        var retry = true;
        function success(descriptors){
            if(descriptors.length > 0){
                self.loadSuggestions(descriptors);
                self.showSuggestions();
                if(descriptors[0].exact || searchFirstSuggested){
                    self.selectSuggestion(0, true);
                    if (searchFirstSuggested) {
                        var isAutoComplete = true;
                        self.search(isAutoComplete);
                    }
                }
            }
        }
        function failure(e){
            if(e === "ZERO_RESULTS" && retry){
                retry = false;
                if(LocationService.debug) console.info("LocationSearch :: Retrying Autocomplete");
                LocationService.search(self.__textInput, "geocode", self.__searchRestrictions).then(success, failure);
            }
            else {
                self.clearSuggestions();
            }
        }
        LocationService.search(this.__textInput, null, this.__searchRestrictions).then(success, failure);
    },

    /** @param {string} label
        @returns {void} */
    setLabel : function(label){
        if (!this.__showLabel) {
            return;
        }
        this.__hostElement.querySelector("label").textContent = label;
    },

    /**
     * Sets the information about where this instance is being used
     * @param {string} page        Name of the page where the instance is being used:
     *                             Ex.: "PRODUCT_PAGE"
     * @param {string} description More detailed description about where on the page it's being used:
     *                             Ex.: "Filter block", "Above listing", ...
     */
    setUseCase : function(page, description) {
        this.__useCase = {
            page: page,
            description: description
        };
    },

    /** @returns {void} */
    loadPreviousSuggestions : function(){
        var previousLocations = LocationService.getPreviousLocations();
        if (previousLocations.length > 0) {
            var defaultLocation = previousLocations[0];
            console.info("Location Search :: Previous Default Location: ", defaultLocation.location);
            this.loadSuggestions(previousLocations, 'Previous Searches');
        }
    },

    /** @param {Array<LocationDescriptor>} descriptors
        @param {string} [label]
        @returns {void} */
    loadSuggestions : function(descriptors, label){
        var items = this.__suggestionlist.querySelectorAll("li");

        this.__selectedSuggestion = null;
        this.__currentSuggestions = descriptors;

        for(var i = 0; i < items.length; i++){
            if(descriptors[i] !== undefined){       // We might have only 1 or 2 suggestions and need to hide the other items
                items[i].setAttribute("hidden", false);
                items[i].setAttribute("data-selected", false);
                items[i].setAttribute("title", descriptors[i].description);
                items[i].setAttribute("data-important", descriptors[i].retailLocation);
                items[i].querySelector("label").textContent = descriptors[i].location;
                items[i].querySelector("small").textContent = descriptors[i].description;
            }
            else {
                items[i].setAttribute("hidden", true);
            }
        }
        this.__suggestionlist.setAttribute('label', label || '')
    },

    /** @returns {void} */
    showSuggestions : function(){
        if(this.__currentSuggestions.length > 0){
            this.__suggestionlist.setAttribute("hidden", false);
        }
    },

    /** @returns {void} */
    hideSuggestions : function(){
        this.__suggestionlist.setAttribute("hidden", true);
    },

    /** @returns {void} */
    clearSuggestions : function(){
        this.hideSuggestions();
        if(this.__selectedSuggestion != null){
            var items = this.__suggestionlist.querySelectorAll("li");
            items[this.__selectedSuggestion].setAttribute("data-selected", false);
            this.__selectedSuggestion = null;
        }
    },

    /** @param {number} index Index of currently loaded suggestions to select
        @param {boolean} autocomplete
        @returns {void} */
    selectSuggestion : function(index, autocomplete){
        if(index > this.__currentSuggestions.length || this.__currentSuggestions.length === 0){
            return;
        }
        var items = this.__suggestionlist.querySelectorAll("li");

        if (!(items && items.length && items[index])) {
            return;
        }

        if(this.__selectedSuggestion != null){
            items[this.__selectedSuggestion].setAttribute("data-selected", false);
        }
        this.__selectedSuggestion = index;

        items[index].setAttribute("data-selected", true);
        if(autocomplete){
            if(this.__input.setSelectionRange != undefined && window.App.Platform.isMobile() === false){
                // Only text select beyond any fully matched text
                this.__input.value = (items[index] && items[index].querySelector("label").textContent) || "";
                var start = this.__input.value.toLowerCase().indexOf(this.__textInput.toLowerCase()) === 0 ? this.__textInput.length : 0;
                this.__input.setSelectionRange(start, this.__input.value.length, "forward");
            }
        }

    },


    __isGeolocationAvailable: function() {
        return window.App.Platform.Supports.geolocation() && this.__geolocation;
    },

    __setupGeolocation: function(isGeolocation) {
        if (isGeolocation) {
            this.__hostElement.querySelector("[data-anonid='geolocate']").removeAttribute("hidden");
            this.__geolocate.disabled = false;
        } else {
            this.__hostElement.querySelector("[data-anonid='geolocate']").setAttribute("hidden", true);
            this.__geolocate.disabled = true;
        }

    },

    /** @returns {void} */
    geolocate : function(){
        var self = this;


        if (!this.__isGeolocationAvailable()) {
            this.__setupGeolocation(false);
            self.__hostElement.querySelector("[data-anonid='geolocate']").setAttribute("hidden", true);
            self.showFeedback("component.mcd.postcodechecker.geoerror", true);
            return;
        }
        var overlay = document.createElement("DIV");
        overlay.id = "browser-overlay";
        document.body.insertBefore(overlay, document.body.firstChild);

        overlay.addEventListener('click', function() {
          document.body.removeChild(overlay);
        });

        var request = LocationService.getGeoLocation();
        request.then(
            function(location){
                document.body.removeChild(overlay);
                self.__isInUserInteraction = true;
                location.useCase = self.__useCase;
                LocationService.setLocation(location);
            },
            function(reason){
                console.error("LocationSearch.GeoLocate :: " +reason);
                document.body.removeChild(overlay);
                self.__isInUserInteraction = true;
                self.__geolocation = false;
                LocationService.clearLocation();
                // hide the 'Get my current position' button on location error as the location is not available
                self.__hostElement.querySelector("[data-anonid='geolocate']").setAttribute("hidden", true);
                // don't display the suggestions list and feedback (error) at the same time
                self.__activeElement = false;
                self.showFeedback("component.mcd.postcodechecker.geoerror", true);
            });
    },

    /** @param {string} message
        @param {boolean} isError
        @param {boolean} isAlreadyTranslated
        @returns {void} */
    showFeedback : function(message, isError, isAlreadyTranslated) {
        // we want just one alert
        if (this.__alert != null) {
            return;
        }

        if (this.__isInUserInteraction) {
            var formatParams = null;
            if (isError) {
                formatParams = {location: LocationService.__locationRequest.input.toUpperCase()};
                message = window.App.locale.getString(message);
                message = window.App.locale.formatString(message, formatParams);
            } else {
                formatParams = {location: LocationService.getLocation().location};
                message = isAlreadyTranslated
                    ? window.App.locale.formatString(message, formatParams)
                    : window.App.locale.getFormattedString(message, formatParams);
            }

            message += "&nbsp;<button type='button' class='message-button'>" + window.App.locale.getString("component.mcd.postcodechecker.search.again.link") + "</button>";

            this.__alert = new UIAlert(isError ? UIAlert.Type.WARNING_MESSAGE : UIAlert.Type.INFO, "", message, "");

            this.__alert.setOnCloseCallback(this.show.bind(this));

            this.hideSuggestions();
            this.hide();

            this.__alert.show(this.__hostElement, UIAlert.Alignment.NONE);
        }
    },

    // hides the content of the component
    hide : function() {
        this.__hostElement.setAttribute('hidden', true);
    },

    // shows the content of the component
    show : function() {
        this.__hostElement.removeAttribute('hidden');
        this.__isInUserInteraction = false;
        this.__alert = null;
    },

    /** @private
        @param {Event} event
        @returns {void} */
    onfocus : function(event){
        if(this.__input.value === ''){
            this.loadPreviousSuggestions();
        }
        else {
            this.selectSuggestion(this.__selectedSuggestion, true);
        }
        this.showSuggestions();
    },

    /** @private
        @param {Event} event
        @returns {void} */
    onblur : function(event){
        this.hideSuggestions();
    },

    /** @private
        @param {Event} event
        @returns {void} */
    oninput : function(event){
        if(this.__textInput === this.__input.value){
            return;
        }
        clearTimeout(this.__timer);
        this.__textInput = this.__input.value;
        if(this.__textInput.length > 1){
            this.__timer = setTimeout(this.autocomplete.bind(this), 750);
        }
        else if(this.__textInput.length > 0){
            this.clearSuggestions();
        }
        else {
            this.clear();
        }
        event.stopPropagation();
        event.preventDefault();
    },

    /** @private
        @description Catch-all for non-compliant browsers for any key that might change the input value
        @param {Event} event
        @returns {void} */
    onkeychange : function(event){
        var ch = String.fromCharCode(event.keyCode);
        if(ch.match(/\w/) || event.keyCode === KeyboardKey.SPACE || event.keyCode === KeyboardKey.BACKSPACE || event.keyCode === KeyboardKey.DELETE) {
            this.oninput(event);
        }
    },

    /** @private
        @description Handle selection list navigation & selection
        @param {Event} event
        @returns {void} */
    onkeydown : function(event){
        if(this.__input.value === ""){
            return;
        }
        var isHandled = false;

        var keyCode = event.keyCode || event.which;
        switch(event.keyCode){
            case KeyboardKey.ENTER:
                if(this.__selectedSuggestion != null){
                    this.search();
                }
                isHandled = true;
                break;
            case KeyboardKey.ESCAPE:
                this.clear();
                isHandled = true;
                break;
            case KeyboardKey.ARROWUP:
                this.showSuggestions();
                if(this.__selectedSuggestion > 0){
                    this.selectSuggestion(this.__selectedSuggestion -1, true);  // Previous
                }
                else {
                    this.selectSuggestion(this.__currentSuggestions.length -1, true);
                }
                isHandled = true;
                break;
            case KeyboardKey.ARROWDOWN:
                this.showSuggestions();
                if(this.__selectedSuggestion !== null && this.__selectedSuggestion < this.__currentSuggestions.length -1){
                    this.selectSuggestion(this.__selectedSuggestion +1, true);  // Next
                }
                else {
                    this.selectSuggestion(0, true);
                }
                isHandled = true;
                break;
            default:
        }

        if(isHandled){
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    },

    /** @private
        @param {Event} event
        @returns {void} */
    onselect : function(event){
        var target = event.target;
        while(target.tagName !== "MENU"){
            if(target.tagName === "LI"){
                var index = 0;
                while(target)    {   // Get the target LI index
                    index++;
                    target = target.previousElementSibling;
                }
                index -= 1;
                if(event.type === "mousedown" || event.type === "touchend"){
                    this.selectSuggestion(index, true);
                    this.search();
                }
                else if(this.__selectedSuggestion !== index){
                    this.selectSuggestion(index, false);
                }
                break;
            }
            else {
                target = target.parentNode;
            }
        }
        if(event.type === "touchend"){
            event.preventDefault();
        }
    },

    /** @private
        @param {Event} event
        @returns {void} */
    onlocationstatechange : function(event){
        var state = event.detail.status;
        this.__hostElement.setAttribute("data-state", state);
        switch(state){
            case LocationService.LocationState.LOADED:
                this.loadPreviousSuggestions();
                this.selectSuggestion(0, true);
                this.__isInUserInteraction = false;
                // We don't show the suggestions until the input field is focused
                break;
            case LocationService.LocationState.READY:
                this.__setupGeolocation(this.__geolocation);
                this.__input.disabled = false;
                if(this.__activeElement || this.__autofocus){
                    this.__input.focus();
                }
                break;
            case LocationService.LocationState.PENDING:
                this.hideSuggestions(); // IE<11
                this.__geolocate.disabled = true;
                if (!this.__isInUserInteraction) {
                    this.hide();
                }
                break;
            case LocationService.LocationState.COMPLETE:
                this.setLabel(window.App.locale.getString("component.mcd.postcodechecker.complete"));
                var descriptor = LocationService.getLocation();
                this.__currentLocation.textContent = descriptor.location;
                this.__activeElement = false;
                this.show();
                break;
            case LocationService.LocationState.INVALID:
                this.clearSuggestions();
                break;
            case LocationService.LocationState.TIMEOUT:
                this.showFeedback("component.mcd.postcodechecker.timeouterror", true);
                break;
            case LocationService.LocationState.ERROR:
                this.showFeedback(event.detail.statusText, true, true);
                break;
            case LocationService.LocationState.FAILED:
                this.showFeedback("component.mcd.postcodechecker.locationerror", true);
                break;
        }
    },

    onclearlocation : function(e){
        this.clearSuggestions();
        this.__textInput = this.__input.value = "";
        this.setLabel(window.App.locale.getString("component.mcd.postcodechecker.check.availability"));
        if (!this.__isInUserInteraction && !e.ignoreUserInteraction) {
            this.hide();
        }
    },

    setUserInteraction: function(isInInteraction) {
      this.__isInUserInteraction = !!isInInteraction;
    },

    /** @param {string} error
        @returns {void} */
    onerror : function(error){}
}

/** @enum {number} */
var KeyboardKey = {
    SPACE : 32,
    ESCAPE : 27,
    ENTER : 13,
    DELETE : 8,
    BACKSPACE : 46,
    ARROWUP : 38,
    ARROWDOWN : 40
}


module.exports = UILocationSearch;
